
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-centre/platforms",
      function () {
        return require("private-next-pages/help-centre/platforms/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-centre/platforms"])
      });
    }
  